import { render, staticRenderFns } from "./BalanceRecord.vue?vue&type=template&id=49516050&scoped=true&"
import script from "./BalanceRecord.vue?vue&type=script&lang=js&"
export * from "./BalanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./BalanceRecord.vue?vue&type=style&index=0&id=49516050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49516050",
  null
  
)

export default component.exports